<script lang="ts">
  export let color = "#F4F5F7";
</script>

<div class="icon-wrapper">
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="margin-top: 5px; margin-left: -2px;"
  >
    <path
      id="Vector"
      d="M0.000108055 7.05927C-0.00260203 7.21851 0.0457227 7.37476 0.138678 7.50734C0.231633 7.63991 0.36483 7.74253 0.520616 7.80161L8.46728 10.8195L11.646 18.3638C11.7074 18.5097 11.8135 18.6348 11.9506 18.7229C12.0876 18.8109 12.2493 18.858 12.4148 18.858H12.4282C12.5958 18.8553 12.7586 18.8045 12.8952 18.7121C13.0317 18.6198 13.1355 18.4903 13.1928 18.3408L19.814 1.05453C19.8679 0.91396 19.8784 0.761702 19.8443 0.615653C19.8102 0.469604 19.7329 0.335833 19.6215 0.230065C19.51 0.124298 19.3691 0.0509298 19.2153 0.0185853C19.0614 -0.0137592 18.901 -0.00373559 18.753 0.0474778L0.544701 6.33319C0.387212 6.38771 0.250846 6.4863 0.153614 6.61593C0.0563824 6.74557 0.0028574 6.90015 0.000108055 7.05927Z"
      fill={color}
    />
  </svg>
</div>
